// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-container {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}
.date-field-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.date-label {
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 0;
  color: #212529;
}
.date-input {
  width: 4rem;
  text-align: center;
}
.date-input::-webkit-inner-spin-button, .date-input::-webkit-outer-spin-button {
  margin: 0;
}
.date-field-group:last-child .date-input {
  width: 5rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/fields/date/date.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;AAIE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,WAAA;EACA,kBAAA;AAHJ;AAKI;EAEE,SAAA;AAJN;AASE;EACE,WAAA;AAPJ","sourcesContent":[".date {\n  &-container {\n    display: flex;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n\n  &-field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  &-label {\n    font-size: 0.875rem;\n    font-weight: 400;\n    margin-bottom: 0;\n    color: #212529;\n  }\n\n  &-input {\n    width: 4rem;\n    text-align: center;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      margin: 0;\n    }\n\n  }\n\n  &-field-group:last-child .date-input {\n    width: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
